<template>
  <header class="page-header" v-bind="$attrs">
    <div class="d-inline-flex">
      <h2>{{ pageTitle }}</h2>
      <hr class="vertical-bar" />
    </div>
    <div class="page-header-body">
      <slot></slot>
    </div>
  </header>
</template>

<script lang="ts">
export default {
  props: {
    pageTitle: {
      required: true,
      type: String,
      default: 'Example Page',
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  display: flex;
  align-items: start;
  padding-top: 3px;
  padding-bottom: 2px;
  margin-bottom: 3px;
  border-bottom: 1px solid #dee2e6;
  gap: 1rem;
}

.page-header .page-header-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
